import t, { z as o } from "zod";
const k = () => ({ url: e, settings: s }) => {
  const { width: n, height: i, smart: l, quality: r } = s ?? {};
  if (!e || !/\/\/a.storyblok.com/.test(e))
    return;
  const a = [
    `${n ?? 0}x${i ?? 0}/`,
    l && "smart/",
    r && `filters:quality(${r})/`
  ].filter(Boolean);
  return `${e}/m/${a.join("")}`;
};
function m(e) {
  return [
    "_storyblok",
    "_storyblok_c",
    "_storyblok_lang",
    "_storyblok_release",
    "_storyblok_rl",
    "_storyblok_tk[space_id]",
    "_storyblok_tk[timestamp]",
    "_storyblok_tk[token]"
  ].every((s) => s in e);
}
const c = o.object({
  gearsResolvedRichText: o.string()
});
function d(e) {
  return c.safeParse(e).success;
}
const y = t.object({
  id: t.string(),
  url: t.string(),
  target: t.string().optional(),
  cached_url: t.string(),
  fieldtype: t.string(),
  linktype: t.string(),
  gearsUrl: t.string()
});
function _(e) {
  return y.safeParse(e).success;
}
const u = o.object({
  unit: o.enum(["days", "hours", "minutes", "seconds"]),
  endTime: o.number(),
  startTime: o.number(),
  isEnabled: o.boolean()
});
function g(e) {
  const s = u.safeParse(e);
  return s.success || console.warn(
    "Failed to parse type StoryblokTimeRangeFieldType: ",
    s.error
  ), s.success;
}
export {
  m as isStoryblokPreviewRequestQuery,
  d as isStoryblokResolvedRichtext,
  _ as isStoryblokStoryLink,
  g as isStoryblokTimeRangeFieldType,
  c as storyblokResolvedRichText,
  y as storyblokStoryLink,
  u as storyblokTimeRangeFieldTypeSchema,
  k as useStoryblokCDN
};
//# sourceMappingURL=lib.es.js.map
